import { DEFAULT_WAVE_COLOR } from '@anm/constants/colors';
export var DEFAULT_VIDEO_META = {
  name: 'Video hosting by Wave.video',
  description: 'This video is hosted on Wave.video, a versatile video marketing platform for business.',
  duration: 'PT10S',
  uploadDate: new Date().toISOString()
};
export var DEFAULT_CONFIGS = {
  bigPlayButton: true,
  autoplay: false,
  end: 'showThumbnail',
  muted: false,
  playerColor: DEFAULT_WAVE_COLOR,
  hideUnmute: false,
  playHidden: false,
  playbar: {
    quality: true,
    currentTime: true,
    fullScreen: true,
    logo: true,
    playbarButton: true,
    smallPlayButton: true,
    volume: true,
    speed: true,
    download: false
  }
};
export var PLAYBAR_CONTROLS = ['currentTime', 'fullScreen', 'logo', 'playbarButton', 'quality', 'smallPlayButton', 'speed', 'volume', 'download'];